import * as actionTypes from './types';

const initialState = {
    loading: false,
    error: false,
    services: []
};
const serviceReducer = (state = { ...initialState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.DELETE_SERVICE_REQUEST:
        case actionTypes.UPDATE_SERVICE_REQUEST:
        case actionTypes.CREATE_NEW_SERVICE_REQUEST:
        case actionTypes.GET_ALL_SERVICES_REQUEST: {
            return {
                ...state,
                error: null,
                loading: true
            };
        }
        case actionTypes.DELETE_SERVICE_SUCCESS:
        case actionTypes.UPDATE_SERVICE_SUCCESS:
        case actionTypes.CREATE_NEW_SERVICE_SUCCESS:
        case actionTypes.GET_ALL_SERVICES_SUCCESS: {
            return {
                ...state,
                services: payload,
                loading: false,
                error: false
            };
        }
        case actionTypes.DELETE_SERVICE_FAILED:
        case actionTypes.UPDATE_SERVICE_FAILED:
        case actionTypes.CREATE_NEW_SERVICE_FAILED:
        case actionTypes.GET_ALL_SERVICES_FAILED: {
            return {
                ...state,
                loading: false,
                error: payload
            };
        }

        default: {
            return {
                ...state
            };
        }
    }
};

export default serviceReducer;
